import classNames from 'classnames';
import { showSuccessToastSmall } from 'shared/lib/notifications';

import { DatePickerHoliday } from './DatePickerHoliday';
import { useHolidaysActions, useHolidaysValues } from './store/store';

interface AddDateProps {
  className?: string;
  year: number;
}

const openToDate = (year: number): Date | undefined => {
  if (new Date().getFullYear() !== year) {
    return new Date(year, 0, 1);
  }
};

export function AddAnotherDate({ className, year }: AddDateProps) {
  const { addHoliday } = useHolidaysActions();
  const holidays = useHolidaysValues();

  const onHolydayAddHandler = (date: Date) => {
    addHoliday(date);

    showSuccessToastSmall('New date was successfully added.');
  };

  return (
    <DatePickerHoliday
      onChange={onHolydayAddHandler}
      openToDate={openToDate(year)}
      holidays={holidays}
    >
      <div className={classNames(className, 'text-deep-blue-500 font-medium text-sm select-none cursor-pointer')}>
        <span className="ml-1 text-lg">+</span> <span className="ml-1">Add another date</span>
      </div>
    </DatePickerHoliday>
  );
}
